import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  appendIndustryCodesFilter,
  removeIndustryCodesFilter,
} from "../../../../../../redux/actions/new-list";
import Collapse from "react-bootstrap/Collapse";
import { InfoTableButton } from "../../../../../library/button";
import { Checkbox } from "../../../../../library/checkbox";
import { Label } from "../../../../../library/label";

const Index = ({ singleIndustry }) => {
  const dispatch = useDispatch();

  const [firstCollapseOpen, setFirstCollapseOpen] = useState(false);
  const [firstCollapseId, setFirstCollapseId] = useState(null);

  const [secondCollapseOpen, setSecondCollapseOpen] = useState(false);
  const [secondCollapseId, setSecondCollapseId] = useState(null);

  const [thirdCollapseOpen, setThirdCollapseOpen] = useState(false);
  const [thirdCollapseId, setThirdCollapseId] = useState(null);

  const [fourthCollapseOpen, setFourthCollapseOpen] = useState(false);
  const [fourthCollapseId, setFourthCollapseId] = useState(null);

  const [fifthCollapseOpen, setFifthCollapseOpen] = useState(false);
  const [fifthCollapseId, setFifthCollapseId] = useState(null);

  const [sixthCollapseOpen, setSixthCollapseOpen] = useState(false);
  const [sixthCollapseId, setSixthCollapseId] = useState(null);

  const filterCodes = useSelector(
    (state) => state.newList.listFilter.industryCodes
  );

  const handleDropdown = (checked, code, index) => {
    if (index === 0) {
      setFirstCollapseOpen(!firstCollapseOpen);
      setFirstCollapseId(code);
    } else if (index === 1) {
      setSecondCollapseOpen(!secondCollapseOpen);
      setSecondCollapseId(code);
    } else if (index === 2) {
      setThirdCollapseOpen(!thirdCollapseOpen);
      setThirdCollapseId(code);
    } else if (index === 3) {
      setFourthCollapseOpen(!fourthCollapseOpen);
      setFourthCollapseId(code);
    } else if (index === 4) {
      setFifthCollapseOpen(!fifthCollapseOpen);
      setFifthCollapseId(code);
    } else if (index === 5) {
      setSixthCollapseOpen(!sixthCollapseOpen);
      setSixthCollapseId(code);
    } else if (index === 6) {
      //skrt
    }
  };

  const selectIndustryCode = (checked, code, parent, index) => {
    if (index === 0) {
      if (checked) {
        setFirstCollapseOpen(true);
        setFirstCollapseId(code);
      } else {
        setFirstCollapseOpen(false);
        setFirstCollapseId(null);
      }
    } else if (index === 1) {
      if (checked) {
        setSecondCollapseOpen(true);
        setSecondCollapseId(code);
      } else {
        setSecondCollapseOpen(false);
        setSecondCollapseId(null);
      }
    } else if (index === 2) {
      if (checked) {
        setThirdCollapseOpen(true);
        setThirdCollapseId(code);
      } else {
        setThirdCollapseOpen(false);
        setThirdCollapseId(null);
      }
    } else if (index === 3) {
      if (checked) {
        setFourthCollapseOpen(true);
        setFourthCollapseId(code);
      } else {
        setFourthCollapseOpen(false);
        setFourthCollapseId(null);
      }
    } else if (index === 4) {
      if (checked) {
        setFifthCollapseOpen(true);
        setFifthCollapseId(code);
      } else {
        setFifthCollapseOpen(false);
        setFifthCollapseId(null);
      }
    } else if (index === 5) {
      if (checked) {
        setSixthCollapseOpen(true);
        setSixthCollapseId(code);
      } else {
        setSixthCollapseOpen(false);
        setSixthCollapseId(null);
      }
    } else if (index === 6) {
      //skrt
    }

    if (checked) {
      dispatch(appendIndustryCodesFilter(code));
    } else {
      dispatch(removeIndustryCodesFilter(code));
    }
  };

  const showIndustryTitle = (phrase, index) => {
    var oldTitle = phrase
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    if (oldTitle.length > 60 && index === 0) {
      return oldTitle.substring(0, 65) + "..";
    } else if (oldTitle.length > 55 && index === 1) {
      return oldTitle.substring(0, 60) + "..";
    } else if (oldTitle.length > 50 && index === 2) {
      return oldTitle.substring(0, 55) + "..";
    } else if (oldTitle.length > 45 && index === 3) {
      return oldTitle.substring(0, 50) + "..";
    } else if (oldTitle.length > 40 && index === 4) {
      return oldTitle.substring(0, 45) + "..";
    } else if (oldTitle.length > 35 && index === 5) {
      return oldTitle.substring(0, 40) + "..";
    } else {
      return oldTitle;
    }
  };

  return (
    <div className="single-code-container">
      <Row className="information-row">
        <Col className="title-col">
          <Checkbox
            checked={
              filterCodes && filterCodes.includes(singleIndustry.code)
                ? true
                : false
            }
            onClick={(e) =>
              selectIndustryCode(e.target.checked, singleIndustry.code, null, 0)
            }
            industryId={singleIndustry.code}
            type="checkbox"
            aria-controls="first-children-container"
            aria-expanded={firstCollapseOpen}
          />
          <Label version={1} weight="bold" data-tip={singleIndustry.title}>
            {showIndustryTitle(singleIndustry.title, 0)}
          </Label>
        </Col>
        <Col className="code-col text-center my-auto">
          <InfoTableButton color="purple" title={singleIndustry.code} />
        </Col>
        <Col className="arrow-col text-right">
          <button
            onClick={(e) =>
              handleDropdown(e.target.checked, singleIndustry.code, 0)
            }
            className={`view-more-button ${firstCollapseOpen ? "down" : "up"}`}
          >
            <i className="fas fa-level-down-alt"></i>
          </button>
        </Col>
      </Row>
      <Collapse
        in={firstCollapseOpen && firstCollapseId === singleIndustry.code}
      >
        <div id="first-children-container">
          {singleIndustry.childIndustries &&
            singleIndustry.childIndustries.map(
              (firstSingleChildren, firstSingleIndex, firstSingleArr) => {
                return (
                  <div
                    className={`single-code-container parent step-one ${
                      firstSingleIndex === 0 ? `first` : ``
                    } ${
                      firstSingleIndex === firstSingleArr.length - 1
                        ? `last`
                        : ``
                    }`}
                  >
                    <Row className="information-row">
                      <Col className="title-col">
                        <Checkbox
                          checked={
                            filterCodes &&
                            filterCodes.includes(firstSingleChildren.code)
                              ? true
                              : false
                          }
                          onClick={(e) =>
                            selectIndustryCode(
                              e.target.checked,
                              firstSingleChildren.code,
                              singleIndustry.code,
                              1
                            )
                          }
                          industryId={firstSingleChildren.code}
                          type="checkbox"
                          aria-controls="second-children-container"
                          aria-expanded={secondCollapseOpen}
                        />
                        <Label
                          version={1}
                          weight="bold"
                          data-tip={firstSingleChildren.title}
                        >
                          {showIndustryTitle(firstSingleChildren.title, 1)}
                        </Label>
                      </Col>
                      <Col className="code-col text-center my-auto">
                        <InfoTableButton
                          color="blue"
                          title={firstSingleChildren.code}
                        />
                      </Col>
                      <Col className="arrow-col text-right">
                        <button
                          onClick={(e) =>
                            handleDropdown(
                              e.target.checked,
                              firstSingleChildren.code,
                              1
                            )
                          }
                          className={`view-more-button ${
                            secondCollapseOpen ? "down" : "up"
                          }`}
                        >
                          <i className="fas fa-level-down-alt"></i>
                        </button>
                      </Col>
                    </Row>
                    <Collapse
                      in={
                        secondCollapseOpen &&
                        secondCollapseId === firstSingleChildren.code
                      }
                    >
                      <div id="second-children-container">
                        {firstSingleChildren.childIndustries &&
                          firstSingleChildren.childIndustries.map(
                            (
                              secondSingleChildren,
                              secondSingleIndex,
                              secondSingleArr
                            ) => {
                              return (
                                <div
                                  className={`single-code-container parent step-two ${
                                    secondSingleIndex === 0 ? `first` : ``
                                  } ${
                                    secondSingleIndex ===
                                    secondSingleArr.length - 1
                                      ? `last`
                                      : ``
                                  }`}
                                >
                                  <Row className="information-row">
                                    <Col className="title-col">
                                      <Checkbox
                                        checked={
                                          filterCodes &&
                                          filterCodes.includes(
                                            secondSingleChildren.code
                                          )
                                            ? true
                                            : false
                                        }
                                        onClick={(e) =>
                                          selectIndustryCode(
                                            e.target.checked,
                                            secondSingleChildren.code,
                                            firstSingleChildren.code,
                                            2
                                          )
                                        }
                                        industryId={secondSingleChildren.code}
                                        type="checkbox"
                                        aria-controls="third-children-container"
                                        aria-expanded={thirdCollapseOpen}
                                      />
                                      <Label
                                        version={1}
                                        weight="bold"
                                        data-tip={secondSingleChildren.title}
                                      >
                                        {showIndustryTitle(
                                          secondSingleChildren.title,
                                          2
                                        )}
                                      </Label>
                                    </Col>
                                    <Col className="code-col text-center my-auto">
                                      <InfoTableButton
                                        color="blue"
                                        title={secondSingleChildren.code}
                                      />
                                    </Col>
                                    <Col className="arrow-col text-right">
                                      <button
                                        onClick={(e) =>
                                          handleDropdown(
                                            e.target.checked,
                                            secondSingleChildren.code,
                                            2
                                          )
                                        }
                                        className={`view-more-button ${
                                          thirdCollapseOpen ? "down" : "up"
                                        }`}
                                      >
                                        <i className="fas fa-level-down-alt"></i>
                                      </button>
                                    </Col>
                                  </Row>
                                  <Collapse
                                    in={
                                      thirdCollapseOpen &&
                                      thirdCollapseId ===
                                        secondSingleChildren.code
                                    }
                                  >
                                    <div id="third-children-container">
                                      {secondSingleChildren.childIndustries &&
                                        secondSingleChildren.childIndustries.map(
                                          (
                                            thirdSingleChildren,
                                            thirdSingleIndex,
                                            thirdSingleArr
                                          ) => {
                                            return (
                                              <div
                                                className={`single-code-container parent step-three ${
                                                  thirdSingleIndex === 0
                                                    ? `first`
                                                    : ``
                                                } ${
                                                  thirdSingleIndex ===
                                                  thirdSingleArr.length - 1
                                                    ? `last`
                                                    : ``
                                                }`}
                                              >
                                                <Row className="information-row">
                                                  <Col className="title-col">
                                                    <Checkbox
                                                      checked={
                                                        filterCodes &&
                                                        filterCodes.includes(
                                                          thirdSingleChildren.code
                                                        )
                                                          ? true
                                                          : false
                                                      }
                                                      onClick={(e) =>
                                                        selectIndustryCode(
                                                          e.target.checked,
                                                          thirdSingleChildren.code,
                                                          secondSingleChildren.code,
                                                          3
                                                        )
                                                      }
                                                      industryId={
                                                        thirdSingleChildren.code
                                                      }
                                                      type="checkbox"
                                                      aria-controls="fourth-children-container"
                                                      aria-expanded={
                                                        fourthCollapseOpen
                                                      }
                                                    />
                                                    <Label
                                                      version={1}
                                                      weight="bold"
                                                      data-tip={
                                                        thirdSingleChildren.title
                                                      }
                                                    >
                                                      {showIndustryTitle(
                                                        thirdSingleChildren.title,
                                                        3
                                                      )}
                                                    </Label>
                                                  </Col>
                                                  <Col className="code-col text-center my-auto">
                                                    <InfoTableButton
                                                      color="blue"
                                                      title={
                                                        thirdSingleChildren.code
                                                      }
                                                    />
                                                  </Col>
                                                  <Col className="arrow-col text-right">
                                                    <button
                                                      onClick={(e) =>
                                                        handleDropdown(
                                                          e.target.checked,
                                                          thirdSingleChildren.code,
                                                          3
                                                        )
                                                      }
                                                      className={`view-more-button ${
                                                        fourthCollapseOpen
                                                          ? "down"
                                                          : "up"
                                                      }`}
                                                    >
                                                      <i className="fas fa-level-down-alt"></i>
                                                    </button>
                                                  </Col>
                                                </Row>
                                                <Collapse
                                                  in={
                                                    fourthCollapseOpen &&
                                                    fourthCollapseId ===
                                                      thirdSingleChildren.code
                                                  }
                                                >
                                                  <div id="fourth-children-container">
                                                    {thirdSingleChildren.childIndustries &&
                                                      thirdSingleChildren.childIndustries.map(
                                                        (
                                                          fourthSingleChildren,
                                                          fourthSingleIndex,
                                                          fourthSingleArr
                                                        ) => {
                                                          return (
                                                            <div
                                                              className={`single-code-container parent step-four ${
                                                                fourthSingleIndex ===
                                                                0
                                                                  ? `first`
                                                                  : ``
                                                              } ${
                                                                fourthSingleIndex ===
                                                                fourthSingleArr.length -
                                                                  1
                                                                  ? `last`
                                                                  : ``
                                                              }`}
                                                            >
                                                              <Row className="information-row">
                                                                <Col className="title-col">
                                                                  <Checkbox
                                                                    checked={
                                                                      filterCodes &&
                                                                      filterCodes.includes(
                                                                        fourthSingleChildren.code
                                                                      )
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    onClick={(
                                                                      e
                                                                    ) =>
                                                                      selectIndustryCode(
                                                                        e.target
                                                                          .checked,
                                                                        fourthSingleChildren.code,
                                                                        thirdSingleChildren.code,
                                                                        4
                                                                      )
                                                                    }
                                                                    industryId={
                                                                      fourthSingleChildren.code
                                                                    }
                                                                    type="checkbox"
                                                                    aria-controls="fifth-children-container"
                                                                    aria-expanded={
                                                                      fifthCollapseOpen
                                                                    }
                                                                  />
                                                                  <Label
                                                                    version={1}
                                                                    weight="bold"
                                                                    data-tip={
                                                                      fourthSingleChildren.title
                                                                    }
                                                                  >
                                                                    {showIndustryTitle(
                                                                      fourthSingleChildren.title,
                                                                      4
                                                                    )}
                                                                  </Label>
                                                                </Col>
                                                                <Col className="code-col text-center my-auto">
                                                                  <InfoTableButton
                                                                    color="blue"
                                                                    title={
                                                                      fourthSingleChildren.code
                                                                    }
                                                                  />
                                                                </Col>
                                                                <Col className="arrow-col text-right">
                                                                  <button
                                                                    onClick={(
                                                                      e
                                                                    ) =>
                                                                      handleDropdown(
                                                                        e.target
                                                                          .checked,
                                                                        fourthSingleChildren.code,
                                                                        4
                                                                      )
                                                                    }
                                                                    className={`view-more-button ${
                                                                      fifthCollapseOpen
                                                                        ? "down"
                                                                        : "up"
                                                                    }`}
                                                                  >
                                                                    <i className="fas fa-level-down-alt"></i>
                                                                  </button>
                                                                </Col>
                                                              </Row>
                                                              <Collapse
                                                                in={
                                                                  fifthCollapseOpen &&
                                                                  fifthCollapseId ===
                                                                    fourthSingleChildren.code
                                                                }
                                                              >
                                                                <div id="fifth-children-container">
                                                                  {fourthSingleChildren.childIndustries &&
                                                                    fourthSingleChildren.childIndustries.map(
                                                                      (
                                                                        fifthSingleChildren,
                                                                        fifthSingleIndex,
                                                                        fifthSingleArr
                                                                      ) => {
                                                                        return (
                                                                          <div
                                                                            className={`single-code-container parent step-five ${
                                                                              fifthSingleIndex ===
                                                                              0
                                                                                ? `first`
                                                                                : ``
                                                                            } ${
                                                                              fifthSingleIndex ===
                                                                              fifthSingleArr.length -
                                                                                1
                                                                                ? `last`
                                                                                : ``
                                                                            }`}
                                                                          >
                                                                            <Row className="information-row">
                                                                              <Col className="title-col">
                                                                                <Checkbox
                                                                                  checked={
                                                                                    filterCodes &&
                                                                                    filterCodes.includes(
                                                                                      fifthSingleChildren.code
                                                                                    )
                                                                                      ? true
                                                                                      : false
                                                                                  }
                                                                                  onClick={(
                                                                                    e
                                                                                  ) =>
                                                                                    selectIndustryCode(
                                                                                      e
                                                                                        .target
                                                                                        .checked,
                                                                                      fifthSingleChildren.code,
                                                                                      fourthSingleChildren.code,
                                                                                      5
                                                                                    )
                                                                                  }
                                                                                  industryId={
                                                                                    fifthSingleChildren.code
                                                                                  }
                                                                                  type="checkbox"
                                                                                  aria-controls="sixth-children-container"
                                                                                  aria-expanded={
                                                                                    sixthCollapseOpen
                                                                                  }
                                                                                />
                                                                                <Label
                                                                                  version={
                                                                                    1
                                                                                  }
                                                                                  weight="bold"
                                                                                  data-tip={
                                                                                    fifthSingleChildren.title
                                                                                  }
                                                                                >
                                                                                  {showIndustryTitle(
                                                                                    fifthSingleChildren.title,
                                                                                    5
                                                                                  )}
                                                                                </Label>
                                                                              </Col>
                                                                              <Col className="code-col text-center my-auto">
                                                                                <InfoTableButton
                                                                                  color="blue"
                                                                                  title={
                                                                                    fifthSingleChildren.code
                                                                                  }
                                                                                />
                                                                              </Col>
                                                                              <Col className="arrow-col text-right">
                                                                                <button
                                                                                  onClick={(
                                                                                    e
                                                                                  ) =>
                                                                                    handleDropdown(
                                                                                      e
                                                                                        .target
                                                                                        .checked,
                                                                                      fifthSingleChildren.code,
                                                                                      5
                                                                                    )
                                                                                  }
                                                                                  className={`view-more-button ${
                                                                                    sixthCollapseOpen
                                                                                      ? "down"
                                                                                      : "up"
                                                                                  }`}
                                                                                >
                                                                                  <i className="fas fa-level-down-alt"></i>
                                                                                </button>
                                                                              </Col>
                                                                            </Row>
                                                                            <Collapse
                                                                              in={
                                                                                sixthCollapseOpen &&
                                                                                sixthCollapseId ===
                                                                                  fifthSingleChildren.code
                                                                              }
                                                                            >
                                                                              <div id="fifth-children-container">
                                                                                {fifthSingleChildren.childIndustries &&
                                                                                  fifthSingleChildren.childIndustries.map(
                                                                                    (
                                                                                      sixthSingleChildren,
                                                                                      sixthSingleIndex,
                                                                                      sixthSingleArr
                                                                                    ) => {
                                                                                      return (
                                                                                        <div
                                                                                          className={`single-code-container parent step-six ${
                                                                                            sixthSingleIndex ===
                                                                                            0
                                                                                              ? `first`
                                                                                              : ``
                                                                                          } ${
                                                                                            sixthSingleIndex ===
                                                                                            sixthSingleArr.length -
                                                                                              1
                                                                                              ? `last`
                                                                                              : ``
                                                                                          }`}
                                                                                        >
                                                                                          <Row className="information-row row">
                                                                                            <Col className="title-col">
                                                                                              <Checkbox
                                                                                                checked={
                                                                                                  filterCodes &&
                                                                                                  filterCodes.includes(
                                                                                                    sixthSingleChildren.code
                                                                                                  )
                                                                                                    ? true
                                                                                                    : false
                                                                                                }
                                                                                                onClick={(
                                                                                                  e
                                                                                                ) =>
                                                                                                  selectIndustryCode(
                                                                                                    e
                                                                                                      .target
                                                                                                      .checked,
                                                                                                    sixthSingleChildren.code,
                                                                                                    fifthSingleChildren.code,
                                                                                                    6
                                                                                                  )
                                                                                                }
                                                                                                industryId={
                                                                                                  sixthSingleChildren.code
                                                                                                }
                                                                                                type="checkbox"
                                                                                              />
                                                                                              <Label>
                                                                                                {
                                                                                                  sixthSingleChildren.title
                                                                                                }
                                                                                              </Label>
                                                                                            </Col>
                                                                                            <Col className="code-col text-center my-auto">
                                                                                              <InfoTableButton
                                                                                                color="blue"
                                                                                                title={
                                                                                                  sixthSingleChildren.code
                                                                                                }
                                                                                              />
                                                                                            </Col>
                                                                                            <Col className="arrow-col text-right">
                                                                                              <button className="view-more-button">
                                                                                                <i className="fas fa-level-down-alt"></i>
                                                                                              </button>
                                                                                            </Col>
                                                                                          </Row>
                                                                                        </div>
                                                                                      );
                                                                                    }
                                                                                  )}
                                                                              </div>
                                                                            </Collapse>
                                                                          </div>
                                                                        );
                                                                      }
                                                                    )}
                                                                </div>
                                                              </Collapse>
                                                            </div>
                                                          );
                                                        }
                                                      )}
                                                  </div>
                                                </Collapse>
                                              </div>
                                            );
                                          }
                                        )}
                                    </div>
                                  </Collapse>
                                </div>
                              );
                            }
                          )}
                      </div>
                    </Collapse>
                  </div>
                );
              }
            )}
        </div>
      </Collapse>
    </div>
  );
};

export default Index;
